<template lang="pug">
  form(action='', @submit.prevent='submit', data-testid="form-export")
    .modal-card
      header.modal-card-head
        p.modal-card-title データダウンロード
      section.modal-card-body
        .content
          p 画面に入力中のデータをファイルにダウンロードします。
        b-field(label='パスワード（任意）', type="is-info" message='※設定した場合、パスワード付きzipファイルを作成します。<br>※半角英数字を使用してください。')
          b-input(type='text' pattern="[0-9a-zA-Z]+" v-model="password" maxlength="8")
      footer.modal-card-foot
        button.button.is-primary(type='submit') ダウンロード
        button.button(type='button', @click='$parent.close') キャンセル
</template>

<script>
import Api from '@/repositories/api'
import Util from '@/utils/util'

export default {
  name: 'DataExportModal',
  props: {
    app_id: {type: String, required: true}, // <ここの名前>.zip
    token: {required: false, default: ''}, // get時に送信するデータ
    data: {required: false, default: null} // post時に送信するデータ
  },
  data () {
    return {
      password: ''
    }
  },
  methods: {
    submit () {
      if (this.data === null) {
        this.getFile()
      } else {
        this.postAndGetFile()
      }
      this.$parent.close()
    },
    /**
     * すでにサーバーにあるjsonファイルをダウンロードする（完了画面用）
     */
    getFile () {
      const ApplicationsApi = Api.get('applications')
      ApplicationsApi
        .getDataFile(this.token, this.app_id, this.password)
        .then(({ data }) => {
          Util.getFileDL(data, this.app_id + '.zip')
        })
        .catch((e) => {
          Util
            .blobToJson(e.response.data)
            .then((data) => {
              this.$notification.open({
                message: data.data.message,
                type: 'is-danger',
                'has-icon': true
              })
            })
        })
    },
    /**
     * 画面上のデータをjsonダウンロードする（作成画面用）
     * @returns {Promise<void>}
     */
    postAndGetFile () {
      const ApplicationsApi = Api.get('applications')
      ApplicationsApi
        .postAndGetDataFile(this.data, this.app_id, this.password)
        .then(({ data }) => {
          Util.getFileDL(data, this.app_id + '.zip')
        })
        .catch((e) => {
          Util
            .blobToJson(e.response.data)
            .then((data) => {
              this.$notification.open({
                message: data.data.message,
                type: 'is-danger',
                'has-icon': true
              })
            })
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/apps/com/DataExportModal.vue